import React from 'react'
import View from '../../atoms/View'
import Text from 'src/components/atoms/TextNew'

interface Props {
  seen_by_dealer: boolean
  updated_at: string
}

const ListRightColumn = ({ seen_by_dealer, updated_at }: Props): JSX.Element => {
  const [date] = updated_at.split(' ')
  return (
    <View className="flex flex-col justify-between pr-4">
      <View className="flex justify-end">
        {!seen_by_dealer && <View className="w-4 h-4 bg-groupBlue rounded-[20px] mt-2" />}
      </View>

      <Text className="text-xl">{date}</Text>
    </View>
  )
}

export default ListRightColumn
